module.exports = __webpack_public_path__ + "img/thanks.f4bbae5d.png";